import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';

export default function PoliticaPrivacidade() {
  return (
    <div className="min-h-screen bg-background">
      <div className="max-w-3xl mx-auto px-4 py-8">
        <Button variant="ghost" asChild className="mb-4 -ml-2">
          <Link to="/auth">
            <ArrowLeft className="mr-2 h-4 w-4" />
            Voltar
          </Link>
        </Button>

        <Card>
          <CardHeader>
            <CardTitle className="text-2xl">Política de Privacidade – Sun7 Link</CardTitle>
            <p className="text-sm text-muted-foreground">
              Última atualização: 22 de fevereiro de 2026
            </p>
          </CardHeader>
          <CardContent className="prose prose-sm max-w-none dark:prose-invert space-y-6">
            {/* 1. Controlador */}
            <section>
              <h2 className="text-lg font-semibold mb-2">1. Controlador dos Dados</h2>
              <p>
                O controlador dos dados pessoais tratados na plataforma Sun7 Link é:
              </p>
              <p>
                <strong>RST SERVIÇOS DE ENGENHARIA LTDA</strong><br />
                CNPJ 37.395.997/0001-36<br />
                R. Belmira Isabel Martins, 42 – Estreito<br />
                Florianópolis/SC – CEP 88075-145
              </p>
            </section>

            {/* 2. Abrangência */}
            <section>
              <h2 className="text-lg font-semibold mb-2">2. Abrangência</h2>
              <p>Esta Política aplica-se a:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Parceiros comerciais autônomos (pessoas físicas ou jurídicas)</li>
                <li>Usuários internos autorizados</li>
                <li>Leads e clientes indicados</li>
                <li>Visitantes da plataforma</li>
              </ul>
            </section>

            {/* 3. Dados Coletados */}
            <section>
              <h2 className="text-lg font-semibold mb-2">3. Dados Coletados</h2>

              <h3 className="text-base font-medium mt-4 mb-2">3.1 Dados de Parceiros</h3>
              <ul className="list-disc pl-6 space-y-1">
                <li>Nome completo</li>
                <li>CPF ou CNPJ</li>
                <li>E-mail</li>
                <li>Telefone</li>
                <li>Cidade e Estado</li>
                <li>Dados bancários (quando aplicável)</li>
                <li>Informações fiscais necessárias ao pagamento de comissões</li>
              </ul>

              <h3 className="text-base font-medium mt-4 mb-2">3.2 Dados de Leads e Clientes</h3>
              <ul className="list-disc pl-6 space-y-1">
                <li>Nome</li>
                <li>CPF/CNPJ</li>
                <li>Telefone</li>
                <li>E-mail</li>
                <li>Endereço</li>
                <li>Informações de consumo de energia</li>
                <li>Dados técnicos necessários à análise de viabilidade técnica</li>
              </ul>

              <h3 className="text-base font-medium mt-4 mb-2">3.3 Dados Técnicos</h3>
              <ul className="list-disc pl-6 space-y-1">
                <li>Endereço IP</li>
                <li>Logs de acesso</li>
                <li>Data e horário de login</li>
                <li>Registros de atividades realizadas na plataforma</li>
              </ul>
            </section>

            {/* 4. Finalidade */}
            <section>
              <h2 className="text-lg font-semibold mb-2">4. Finalidade do Tratamento</h2>
              <p>Os dados pessoais são tratados para as seguintes finalidades:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Cadastro, autenticação e gestão de usuários da plataforma</li>
                <li>Registro e organização de indicações realizadas pelos parceiros</li>
                <li>Processamento interno de dados para análise técnica e comercial pela CONTRATANTE</li>
                <li>Geração automatizada de simulações comerciais pela plataforma, sempre sujeitas à validação técnica, aprovação interna e formalização exclusiva pela CONTRATANTE</li>
                <li>Elaboração, validação e assinatura de propostas e contratos exclusivamente pela CONTRATANTE</li>
                <li>Controle e apuração de comissões geradas, pagas e pendentes</li>
                <li>Cumprimento de obrigações legais, fiscais e regulatórias</li>
                <li>Prevenção a fraudes e garantia da segurança da informação</li>
                <li>Exercício regular de direitos em processos administrativos ou judiciais</li>
              </ul>
              <p className="mt-2">
                A utilização da plataforma pelo parceiro não implica concessão de poderes de representação, negociação ou formalização contratual em nome da CONTRATANTE.
              </p>
            </section>

            {/* 5. Base legal */}
            <section>
              <h2 className="text-lg font-semibold mb-2">5. Base Legal (LGPD – Lei 13.709/2018)</h2>
              <p>O tratamento de dados ocorre com fundamento em:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Execução de contrato</li>
                <li>Cumprimento de obrigação legal ou regulatória</li>
                <li>Legítimo interesse do controlador</li>
                <li>Exercício regular de direitos</li>
                <li>Consentimento do titular, quando aplicável</li>
              </ul>
            </section>

            {/* 6. Compartilhamento */}
            <section>
              <h2 className="text-lg font-semibold mb-2">6. Compartilhamento de Dados</h2>
              <p>Os dados poderão ser compartilhados, quando necessário, com:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Escritório contábil</li>
                <li>Instituições financeiras</li>
                <li>Prestadores de serviços de tecnologia e hospedagem</li>
                <li>Distribuidores e fornecedores envolvidos na execução contratual</li>
                <li>Órgãos públicos, mediante obrigação legal</li>
              </ul>
              <p className="mt-2">Não há comercialização de dados pessoais.</p>
            </section>

            {/* 7. Retenção */}
            <section>
              <h2 className="text-lg font-semibold mb-2">7. Retenção</h2>
              <p>Os dados serão armazenados:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Durante a vigência da relação contratual</li>
                <li>Pelo prazo necessário ao cumprimento de obrigações legais e fiscais</li>
                <li>Pelo prazo prescricional aplicável a eventuais responsabilidades</li>
              </ul>
              <p className="mt-2">Após esse período, poderão ser eliminados ou anonimizados.</p>
            </section>

            {/* 8. Direitos do titular */}
            <section>
              <h2 className="text-lg font-semibold mb-2">8. Direitos do Titular</h2>
              <p>Nos termos do Art. 18 da LGPD, o titular poderá solicitar:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Confirmação da existência de tratamento</li>
                <li>Acesso aos dados</li>
                <li>Correção de dados inexatos ou desatualizados</li>
                <li>Anonimização, bloqueio ou eliminação (quando aplicável)</li>
                <li>Portabilidade</li>
                <li>Revogação do consentimento</li>
              </ul>
              <p className="mt-2">Solicitações deverão ser feitas pelos canais oficiais da empresa.</p>
            </section>

            {/* 9. Segurança */}
            <section>
              <h2 className="text-lg font-semibold mb-2">9. Segurança</h2>
              <p>
                São adotadas medidas técnicas e administrativas adequadas à proteção dos dados pessoais contra acesso não autorizado, perda, alteração ou divulgação indevida.
              </p>
            </section>

            {/* 10. Responsabilidade do Parceiro */}
            <section>
              <h2 className="text-lg font-semibold mb-2">10. Responsabilidade do Parceiro</h2>
              <p>O parceiro declara que:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Coletará dados de leads com base legal válida</li>
                <li>Utilizará os dados exclusivamente para fins relacionados à indicação</li>
                <li>Não realizará negociação, formalização ou assinatura de contratos em nome da CONTRATANTE</li>
                <li>Responderá por eventual coleta ou uso irregular de dados</li>
              </ul>
            </section>

            {/* 11. Alterações */}
            <section>
              <h2 className="text-lg font-semibold mb-2">11. Alterações</h2>
              <p>
                Esta Política poderá ser atualizada a qualquer tempo. A versão vigente será sempre aquela publicada na plataforma.
              </p>
            </section>

            <div className="pt-4 border-t">
              <p className="text-sm text-muted-foreground">
                Esta Política está em conformidade com a Lei Geral de Proteção de Dados (Lei nº 13.709/2018) e com o Marco Civil da Internet (Lei nº 12.965/2014).
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
